<template>
  <TitleCard :title="titleCard" :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="head-top-wrap">
        <div class="form-table-wrap">
          <Form ref="form" layoutType="grid" :optionList="formRow" :defaultModel="defaultValue"></Form>
          <div class="operation-wrap">
            <a-button @click="clearAll">清空条件</a-button>
            <a-button @click="toSearch">搜索</a-button>
          </div>
        </div>
        <TableToolsWrap
          needLeft
          :btnList="utilsBtnList"
          @utilsClick="handlerActionClick"
        ></TableToolsWrap>
      </div>
      <Table
        ref="table"
        :options="fields"
        :tableValue="tableValue"
        :customSlotOpt="slotOpt"
        :otherOpt="customOtherOpt"
        @change="initTableValue"
        @actionClick="handlerActionClick"
      ></Table>
    </div>
    <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
  </TitleCard>
</template>

<script>
import Table from '../../components/table/index.vue'
import Form from '../../components/formTable/form.vue'
import AModal from '../../components/AModal'
import TableToolsWrap from '../../components/common/tableToolsWrap.vue'
import makeFakerData from '@/mixins/makeFakerData'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import {
  fields,
  slotOpt,
  formRow
} from './configs/configs'
import {
  getAnnounceInfos, deleteAnnounceInfos, issueAnnounceInfos, dropAnnounceInfos
} from '@/api/announceApi.js'

export default {
  mixins: [mixinsBackStack, makeFakerData],
  data() {
    return {
      slotOpt,
      fields,
      formRow,
      // otherOpt,
      customOtherOpt: {
        pagination: {
          total: 0,
          pageNum: 1,
          current: 1,
          pageSize: 10
        }
      },
      tableValue: [],
      defaultSearchParam: { searchValue: '0' },
      defaultValue: {
        searchValue: '0'
      },
      utilsBtnList: [
        { name: '新增', cb: 'createAnnounce' },
        { name: '发布', cb: 'issue' },
        { name: '下架', cb: 'drop' },
        { name: '删除', cb: 'batchDelete' }
      ]
    }
  },
  components: {
    Table,
    Form,
    TableToolsWrap,
    AModal
  },
  mounted() {
    this.initSearchParams() // 重置搜索的参数
    this.initTableValue()
  },
  methods: {
    async initTableValue() {
      try {
        this.loadingTable(true) // 开启表格的加载动画
        const params = this.handlerBeforeRequestParams()
        const { rows, total } = await getAnnounceInfos(params) // 请求表格数据接口
        const row = this.handlerDateFormat(rows) // 处理时间格式
        this.handlerResultMappings(rows) // 处理数据的映射关系
        this.tableValue = row
        this.customOtherOpt.pagination.total = total
        this.tableValue.forEach(item=>{
          if(item.status === '0'){
            item.statusText = '未发布'
          }else{
            item.statusText = '已发布'
          }
          this.initSelectedRowIds() // 清空勾选的选项
        })
        
      } catch (error) {
        this.$apiStatusHandler(99, error.msg) // 请求异常，则全局轻提示
      } finally {
        this.loadingTable(false)
      }
    },
    // 请求前的参数收集
    handlerBeforeRequestParams() {
      const { pagination } = this.$refs.table
      const { pageSize, pageNum } = pagination
      const params = {
        ...this.searchParam,
        pageNum,
        pageSize
      }
      return params
    },
    createAnnounce() {
      this.$router.push({
        name: 'informationOperation',
        query: { type: 'create' }
      })
    },
    // 前往详情
    toDetail(row) {
      const { id } = row.scope
      this.$router.push({ name: 'informationOperation', query: { type: 'detail', id } })
    },
    // 编辑公告
    edit(row) {
      const forbidden = ['1']
      const check = forbidden.includes(row.status)
      if(check) {
        return this.$apiStatusHandler(999, '只有待发布的交易公告允许编辑')
      }
      this.$router.push({
        name: 'informationOperation',
        query: { type: 'edit', id: row.id }
      })
    },
    issue() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const forbidden = ['1']
      const check = selectedIds.filter(item => forbidden.includes(item.status))
      if(check.length !== 0) {
        return this.$apiStatusHandler(999, '只有待发布的交易公告允许发布')
      }
      if(selectedIds.length === 0){
        return this.$apiStatusHandler(999, '您还未选中需要操作的交易公告!')
      }
      const idstatus = selectedIds.map((item) => item.id)
      this.customModalOpt.contentTips = '是否确定发布该内容'
      this.beforeShowModal(true, {
        source: 'dealIssueApi',
        params: { ids: idstatus }
      })
    },
    // 调用发布接口
    async dealIssueApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await issueAnnounceInfos(ids)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 下架
    drop() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const forbidden = ['0']
      const check = selectedIds.filter(item => forbidden.includes(item.status))
      if(check.length !== 0) {
        return this.$apiStatusHandler(999, '只有已发布的交易公告允许下架')
      }
      const idstatus = selectedIds.map((item) => item.id)
      this.customModalOpt.contentTips = '是否确定下架已选的交易公告'
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的交易公告')
      }
      this.beforeShowModal(true, {
        source: 'dealDropApi',
        params: { ids: idstatus }
      })
    },
    // 调用下架接口
    async dealDropApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await dropAnnounceInfos(ids)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 单独删除
    singleDelete(row) {
      if(row.status === '1') {
        return this.$apiStatusHandler(999, '只有待发布的交易公告允许删除')
      }
      this.customModalOpt.contentTips = '是否确定删除该交易公告'
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: row.id }
      })
    },
    // 批量删除
    batchDelete() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const forbidden = ['1']
      const check = selectedIds.filter(item => forbidden.includes(item.status))
      if(check.length !== 0) {
        return this.$apiStatusHandler(999, '只有待发布的交易公告允许删除')
      }
      const idstatus = selectedIds.map((item) => item.id)
      this.customModalOpt.contentTips = '是否确定删除已选的交易公告'
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的交易公告')
      }
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: idstatus }
      })
    },
    // 调用删除接口
    async dealDeleteApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await deleteAnnounceInfos(ids)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    }
  }
}
</script>
